import { ITitleWithSelector } from './types';

export const mockTitleWithSelector: ITitleWithSelector = {
  textColor: 'white',
  bannerTitle: 'Help Center',
  bannerDescription:
    'Find answers to your questions, get help with our products',
  dropdownLabel: 'Region',
  dropDownItems: [
    { linkText: 'US', newTab: true, linkPath: '/us/help-center' },
    { linkText: 'Canada', newTab: false, linkPath: '/us/help-center' },
    { linkText: 'France', newTab: true, linkPath: '/us/help-center' },
  ],
};

export const mockProps = {
  bannerTitle: 'Test Banner Title',
  bannerDescription: 'Test Description',
  dropdownLabel: 'Select Region',
  dropDownItems: [
    { linkText: 'item 1', linkPath: '/path1', newTab: false },
    { linkText: 'item 2', linkPath: '/path2', newTab: false },
    { linkText: 'item 3', linkPath: '/path3', newTab: false },
  ],
};

export const mockTextColor = 'white';
export const mockTextColorBlack = 'black';
